import React from "react";
import './Tabs.css';

const Tabs = ({ tabs = [], activeIndex = 0, onTabSelect }) => {
    return (
        <div className="tabs-container">
            {tabs.map((tab, index) => (
                <div
                    key={index}
                    className={`tab-item ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => onTabSelect(index)}
                >
                    {tab}
                </div>
            ))}
        </div>
    );
};

export default Tabs;